/* ==========================================================================
   SIZE FINDER: steps, typed numbers and URL state

   Needs size-logic.js loaded first (sel, match, render, showAll, CATALOG).
   The section loads the three finder files itself, deferred, in this order:
   size-logic.js, size-finder-ui.js, benshome-picker.js.

   URL STATE. On arrival the finder reads ?type, w, d, c and all:
     all=1                 every size
     type=sofa-med         that furniture, step 2
     type + w + d (+ c)    the answer, step 3
     w + d, no type        the first non-sectional size whose width band holds
                           w; if none does, step 1 with the numbers filled in
   After every answer the address is rewritten to ?type&w&d[&c] with
   replaceState, so a reload, a back button or a shared link shows the same
   answer. Other parameters (preview_theme_id and friends) are kept.

   Nothing on this page adds to the cart. Buttons in the answer carry
   data-bh-add and benshome-cart.js adds only when one is pressed.
   ========================================================================== */
(function(){
  if(typeof sel === 'undefined' || typeof match !== 'function' || typeof render !== 'function') return;

  var TYPES = ['recliner','loveseat','sofa-med','sofa-long','sectional'];
  var prefilled = false;

  function el(id){ return document.getElementById(id); }
  function reduceMotion(){
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){ return false; }
  }
  function fmt(n){ return String(Math.round(Number(n) * 100) / 100); }
  function onReady(fn){
    if(document.readyState === 'complete'){ setTimeout(fn, 0); return; }
    var done = false;
    function once(){ if(done) return; done = true; fn(); }
    document.addEventListener('DOMContentLoaded', once);
    window.addEventListener('load', once);
  }

  /* ---------- step navigation ---------- */
  function go(n, opts){
    opts = opts || {};
    var step = el('s' + n);
    if(!step) return;
    document.querySelectorAll('#finder .fstep').forEach(function(e){ e.classList.remove('on'); });
    step.classList.add('on');
    [1,2,3].forEach(function(i){ var b = el('b' + i); if(b) b.classList.toggle('on', i <= n); });

    var box = document.querySelector('#finder .finder-box');
    if(box && !opts.noScroll){
      window.scrollTo({top: box.getBoundingClientRect().top + window.scrollY - 80,
                       behavior: reduceMotion() ? 'auto' : 'smooth'});
    }
    // Keyboard and screen reader users land on the new step's heading.
    if(!opts.noFocus){
      var h = n === 3 ? el('rhead') : (step.querySelector('.fstep-h') || step.querySelector('h3'));
      if(h){
        if(!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
        try { h.focus({preventScroll:true}); } catch(e){ h.focus(); }
      }
    }
  }
  window.bhFinderGo = go;

  function openManual(focusId){
    var m = document.querySelector('#finder details.manual');
    if(m) m.open = true;
    var f = focusId ? el(focusId) : null;
    if(f) setTimeout(function(){ try { f.focus(); } catch(e){} }, 60);
  }
  window.bhFinderManual = openManual;

  /* ---------- step 1: furniture ---------- */
  function selectType(type){
    if(TYPES.indexOf(type) < 0) return false;
    document.querySelectorAll('#finder .type').forEach(function(x){
      x.setAttribute('aria-pressed', x.getAttribute('data-type') === type ? 'true' : 'false');
    });
    sel.type = type;

    // Sectionals need the chaise width as well; relabel the fields to match.
    var isSec = type === 'sectional';
    var cw = el('chaiseWrap');
    if(cw) cw.classList.toggle('on', isSec);
    var wl = el('wlabel');
    if(wl){ var lt = wl.getAttribute(isSec ? 'data-sectional' : 'data-default'); if(lt) wl.textContent = lt; }
    var wh = el('whint');
    if(wh){
      var key = isSec ? 'data-sectional' : (type === 'recliner' ? 'data-recliner' : 'data-default');
      var ht = wh.getAttribute(key);
      if(ht) wh.textContent = ht;
    }
    // The drawing in the typed panel follows the same switch: the recliner
    // (narrowest point) or sectional (L-shape) drawing instead of the plain
    // width one. Depth is always shown.
    var dmView = isSec ? 'sectional' : (type === 'recliner' ? 'recliner' : 'width');
    document.querySelectorAll('#finder .dm-finder [data-dm-view]').forEach(function(f){
      var v = f.getAttribute('data-dm-view');
      f.hidden = !(v === 'depth' || v === dmView);
    });
    if(typeof window.bhPickerBuild === 'function') window.bhPickerBuild(type);
    return true;
  }

  document.querySelectorAll('#finder .type').forEach(function(b){
    b.addEventListener('click', function(){
      if(!selectType(b.getAttribute('data-type'))) return;
      setTimeout(function(){
        go(2);
        if(prefilled) openManual(null);
      }, 130);
    });
  });

  /* ---------- cm helper ---------- */
  function cmHint(input, note){
    input.addEventListener('input', function(){
      var v = parseFloat(input.value);
      note.textContent = (v > 0) ? '≈ ' + Math.round(v * 2.54) + ' cm' : '';
    });
  }
  [['w','wcm'],['d','dcm'],['c','ccm']].forEach(function(pair){
    var x = el(pair[0]), y = el(pair[1]);
    if(x && y) cmHint(x, y);
  });

  /* ---------- validate + calculate ---------- */
  function readNum(input){
    if(!input) return NaN;
    return parseFloat(String(input.value || '').replace(',', '.'));
  }
  function showErr(errId, input, msg){
    var e = el(errId);
    if(e){ e.textContent = msg; e.classList.add('on'); }
    if(input) input.setAttribute('aria-invalid', 'true');
  }
  function clearErr(errId, input){
    var e = el(errId);
    if(e){ e.textContent = ''; e.classList.remove('on'); }
    if(input) input.removeAttribute('aria-invalid');
  }
  function offMsg(lo, hi){
    return "That looks off. We'd expect something between " + lo + ' and ' + hi + ' inches.';
  }

  function validate(quiet){
    var isSec = sel.type === 'sectional';
    var wEl = el('w'), dEl = el('d'), cEl = el('c');
    var w = readNum(wEl), d = readNum(dEl), c = readNum(cEl);
    var first = null;
    clearErr('werr', wEl); clearErr('derr', dEl); clearErr('cerr', cEl);

    if(!w){ showErr('werr', wEl, 'Please enter the width in inches.'); first = first || wEl; }
    else if(w < 10 || w > 200){ showErr('werr', wEl, offMsg(10, 200)); first = first || wEl; }

    if(isSec){
      if(!c){ showErr('cerr', cEl, 'Sectionals need the chaise width too.'); first = first || cEl; }
      else if(c < 10 || c > 120){ showErr('cerr', cEl, offMsg(10, 120)); first = first || cEl; }
    }

    if(!d){ showErr('derr', dEl, 'Please enter the seat depth in inches.'); first = first || dEl; }
    else if(d < 8 || d > 60){ showErr('derr', dEl, offMsg(8, 60)); first = first || dEl; }

    if(first){
      openManual(null);
      if(!quiet){
        try { first.focus({preventScroll:true}); } catch(e){ try { first.focus(); } catch(e2){} }
        try { first.scrollIntoView({block:'center', behavior: reduceMotion() ? 'auto' : 'smooth'}); } catch(e){}
      }
      return null;
    }
    return {w:w, d:d, c:isSec ? c : null};
  }

  function writeUrl(){
    if(!window.history || typeof history.replaceState !== 'function') return;
    try {
      var q = new URLSearchParams(location.search);
      ['type','w','d','c','all'].forEach(function(k){ q.delete(k); });
      q.set('type', sel.type);
      q.set('w', fmt(sel.w));
      q.set('d', fmt(sel.d));
      if(sel.type === 'sectional' && sel.c != null) q.set('c', fmt(sel.c));
      history.replaceState(history.state, '', location.pathname + '?' + q.toString() + location.hash);
    } catch(e){}
  }

  function run(via, opts){
    opts = opts || {};
    if(!sel.type){ go(1); return; }
    var v = validate(!!opts.quiet);
    if(!v){
      // Numbers from a link that do not validate: show them on step 2 with
      // the error under the field, rather than on a step nobody can see.
      if(opts.quiet) go(2, {noFocus:true});
      return;
    }
    sel.w = v.w; sel.d = v.d; sel.c = v.c;
    render(match(sel.type, v.w, v.d, sel.c), via);
    go(3, opts);
    writeUrl();
  }

  /* The range buttons fill the fields and press Calculate with
     data-via="chips", so both paths go through the same validation. */
  var calc = el('calc');
  if(calc) calc.addEventListener('click', function(){
    var via = calc.getAttribute('data-via') || 'typed';
    calc.removeAttribute('data-via');
    run(via === 'chips' ? 'chips' : 'typed');
  });

  var back1 = el('back1');
  if(back1) back1.addEventListener('click', function(){ go(1); });

  /* ---------- actions printed inside the answer ---------- */
  var finder = el('finder');
  if(finder) finder.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('[data-finder-go],[data-finder-all]') : null;
    if(!t || !finder.contains(t)) return;
    e.preventDefault();
    if(t.hasAttribute('data-finder-all')){
      if(typeof showAll === 'function'){ go(3, {noScroll:true}); showAll(); }
      return;
    }
    var n = parseInt(t.getAttribute('data-finder-go'), 10) || 2;
    if(n > 1 && !sel.type) n = 1;
    go(n);
    var f = t.getAttribute('data-finder-focus');
    if(f && n === 2) openManual(f);
  });

  /* ---------- URL state ---------- */
  function fill(w, d, c){
    var wEl = el('w'), dEl = el('d'), cEl = el('c');
    if(wEl && w != null) wEl.value = fmt(w);
    if(dEl && d != null) dEl.value = fmt(d);
    if(cEl && c != null) cEl.value = fmt(c);
  }

  function fromUrl(){
    var q;
    try { q = new URLSearchParams(location.search); } catch(e){ return; }
    if(!el('finder')) return;

    if(q.get('all') === '1'){
      if(typeof showAll === 'function'){ go(3, {noFocus:true, noScroll:true}); showAll(); }
      return;
    }

    var type = q.get('type');
    var w = parseFloat(q.get('w')), d = parseFloat(q.get('d')), c = parseFloat(q.get('c'));
    var hasWD = isFinite(w) && isFinite(d) && w > 0 && d > 0;
    var hasC  = isFinite(c) && c > 0;

    if(TYPES.indexOf(type) < 0){
      type = null;
      if(!hasWD) return;
      var list = (typeof CATALOG !== 'undefined' && Array.isArray(CATALOG)) ? CATALOG : [];
      for(var i = 0; i < list.length; i++){
        var p = list[i];
        if(p.type !== 'sectional' && w >= p.min && w <= p.max){ type = p.type; break; }
      }
      if(!type){
        // No width band holds it: stay on step 1 with the numbers kept.
        fill(w, d, hasC ? c : null);
        prefilled = true;
        return;
      }
    }

    selectType(type);
    if(hasWD){
      fill(w, d, hasC ? c : null);
      if(type === 'sectional' && !hasC){
        prefilled = true;
        go(2, {noFocus:true});
        openManual(null);
        return;
      }
      run('url', {noFocus:true, quiet:true});
      return;
    }
    go(2, {noFocus:true});
  }

  onReady(fromUrl);
})();
